import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function Metric({ label, value, sub, tone = "default", testid }) {
  const toneCls = { default: "text-foreground", primary: "text-primary", success: "text-emerald-600", warning: "text-amber-600", danger: "text-red-600" }[tone];
  return (
    <Card className="border-border shadow-none" data-testid={testid}>
      <CardContent className="p-5">
        <div className="overline mb-3">{label}</div>
        <div className={`text-metric text-3xl ${toneCls}`}>{value}</div>
        {sub && <div className="text-xs text-muted-foreground mt-1.5">{sub}</div>}
      </CardContent>
    </Card>
  );
}

const STATUS_MAP = {
  "In Progress": "bg-amber-100 text-amber-700 border-amber-200",
  "Completed":   "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Pending":     "bg-slate-100 text-slate-700 border-slate-200",
  "On Hold":     "bg-orange-100 text-orange-700 border-orange-200",
  "Rejected":    "bg-red-100 text-red-700 border-red-200",
  "Passed":      "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Failed":      "bg-red-100 text-red-700 border-red-200",
  "Running":     "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Idle":        "bg-slate-100 text-slate-700 border-slate-200",
  "Maintenance": "bg-amber-100 text-amber-700 border-amber-200",
  "Breakdown":   "bg-red-100 text-red-700 border-red-200",
  "Received":    "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Dispatched":  "bg-blue-100 text-blue-700 border-blue-200",
  "Delivered":   "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Picked":      "bg-blue-100 text-blue-700 border-blue-200",
  "Packed":      "bg-indigo-100 text-indigo-700 border-indigo-200",
};

export function StatusBadge({ status, testid }) {
  const cls = STATUS_MAP[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${cls}`}
    >
      {status || "—"}
    </span>
  );
}

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6 animate-fade-in" data-testid={testid}>
      <div>
        <div className="overline mb-1.5">{subtitle}</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter">{title}</h1>
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
